import React from 'react';
import { Box, Typography, Button, alpha } from '@mui/material';
import {
  Inbox,
  Search,
  Add,
  FilterList,
  Error,
  CloudOff,
} from '@mui/icons-material';

const iconMap = {
  empty: Inbox,
  search: Search,
  filter: FilterList,
  error: Error,
  offline: CloudOff,
};

const EmptyState = ({
  icon = 'empty',
  title = 'No hay datos',
  description,
  actionLabel,
  onAction,
  actionIcon,
  size = 'medium',
  sx = {},
}) => {
  const IconComponent = typeof icon === 'string' ? iconMap[icon] || Inbox : icon;
  
  const sizeConfig = {
    small: {
      iconSize: 48,
      iconPadding: 2,
      titleVariant: 'subtitle1',
      descVariant: 'body2',
      spacing: 2,
    },
    medium: {
      iconSize: 64,
      iconPadding: 2.5,
      titleVariant: 'h6',
      descVariant: 'body2',
      spacing: 3,
    },
    large: {
      iconSize: 80,
      iconPadding: 3,
      titleVariant: 'h5',
      descVariant: 'body1',
      spacing: 4,
    },
  };

  const config = sizeConfig[size] || sizeConfig.medium;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: config.spacing * 2,
        px: 3,
        ...sx,
      }}
    >
      <Box
        sx={{
          p: config.iconPadding,
          borderRadius: '50%',
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
          mb: config.spacing,
        }}
      >
        <IconComponent
          sx={{
            fontSize: config.iconSize,
            color: 'text.secondary',
          }}
        />
      </Box>
      <Typography
        variant={config.titleVariant}
        sx={{
          fontWeight: 600,
          color: 'text.primary',
          mb: 1,
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant={config.descVariant}
          sx={{
            color: 'text.secondary',
            maxWidth: 400,
            mb: actionLabel ? 3 : 0,
          }}
        >
          {description}
        </Typography>
      )}
      {actionLabel && (
        <Button
          variant="contained"
          onClick={onAction}
          startIcon={actionIcon || <Add />}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
